import "./App.css";
import About from "./components/aboutNskills/about";
import Expertise from "./components/expertise/expertise";
import Footer from "./components/footer/footer";
import HeroScreen from "./components/heroscreen/heroscreen";
import ProjectCarousel from "./components/projects/projectCarousel";
import ProjectList from "./components/projects/projectlist";
import Socials from "./components/socials/socials";
import { ProjectProvider } from "./providers/projectProvider";
import { Loading } from "./components/loading";
import { useEffect, useState } from "react";
import useInViewObserver from "./hooks/useInView";
import { AlertProvider } from "./providers/AlertContext";
import BottomFooter from "./components/footer/bottomFooter";
import NewHeader from "./components/header/NewHeader";
import ReactGA from "react-ga4";

function App() {
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(1);
  const [projectCarouselRef, projectCarouselInView] = useInViewObserver();
  const [footerRef, footerInView] = useInViewObserver();

  useEffect(() => {
    ReactGA.initialize("G-V6DBYPR9Z4");

    // Track page view
  }, []);

  // 10
  useEffect(() => {
    const timer = setTimeout(() => {
      if (counter < 100) {
        setCounter(counter + 1);
      } else {
        clearTimeout(timer);
        setTimeout(() => {
          setLoading(false);
        }, 1);
      }
    }, 1);

    return () => clearTimeout(timer);
  }, [counter]);

  useEffect(() => {
    if (loading) {
      document.body.classList.add("overflow-hidden");
    } else {
      setTimeout(() => {
        document.body.classList.remove("overflow-hidden");
      }, 1000);
    }
  });
  return (
    <AlertProvider>
      <div className="App">
        <Loading loading={loading} counter={counter} />

        <NewHeader />

        <HeroScreen loading={loading} />

        <About />
        <Expertise />

        <ProjectProvider>
          <ProjectList />

          <div ref={projectCarouselRef} className="projectCarousel">
            <ProjectCarousel />
          </div>
        </ProjectProvider>

        <Socials inView={projectCarouselInView || footerInView} />

        <div ref={footerRef} className="footerComponent">
          <Footer />
        </div>
      </div>

      <BottomFooter />


      
    </AlertProvider>
  );
}

export default App;
